import { Component } from '@angular/core';

@Component({
  selector: 'app-places',
  templateUrl: './places.component.html',
  styleUrls: ['./places.component.css']
})
export class PlacesComponent {

   goToCeremony() {
    window.open('https://maps.app.goo.gl/1JUfgwEB9QkS3bVX6', '_blank');
  }
}
